<template>
  <el-dialog
    :title="popupConfig.title"
    :visible.sync="dialogVisible"
    width="50%"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
      v-loading="loading"
    >
      <el-form-item label="话术标题" prop="title">
        <el-input
          v-model="ruleForm.title"
          maxlength="50"
          size="mini"
          placeholder="请输入"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="一级分类" prop="oneClassId">
            <el-select
              size="mini"
              v-model="ruleForm.oneClassId"
              :placeholder="oneOptions.length > 0 ? '请选择' : '无数据'"
              v-loading="loading1"
              @change="
                ruleForm.twoClassId = '';
                ruleForm.threeClassId = '';
                getTwoClassData();
              "
            >
              <el-option
                v-for="item in oneOptions"
                :key="item.classId"
                :label="item.className"
                :value="item.classId"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="二级分类" prop="twoClassId">
            <el-select
              size="mini"
              v-model="ruleForm.twoClassId"
              :placeholder="twoOptions.length > 0 ? '请选择' : '无数据'"
              v-loading="loading2"
              @change="
                ruleForm.threeClassId = '';
                getThreeClassData();
              "
            >
              <el-option
                v-for="item in twoOptions"
                :key="item.classId"
                :label="item.className"
                :value="item.classId"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="三级分类" prop="threeClassId">
            <el-select
              size="mini"
              v-model="ruleForm.threeClassId"
              :placeholder="threeOptions.length > 0 ? '请选择' : '无数据'"
              v-loading="loading3"
            >
              <el-option
                v-for="item in threeOptions"
                :key="item.classId"
                :label="item.className"
                :value="item.classId"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="排序值" prop="orderNo">
            <el-input
              v-model.number="ruleForm.orderNo"
              placeholder="请输入排序值"
              size="mini"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item label="话术内容" prop="content">
        <MyUpload
          ref="myUploadRef"
          :myType="6"
          @receiveParam="receiveParam"
          :showApplet="false"
        />
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="handleClose">取 消</el-button>
      <!-- //保存  不重置  不关窗 -->
      <el-button
        type="primary"
        size="small"
        :disabled="submitting"
        @click="submitForm('ruleForm')"
        >保 存
      </el-button>
      <!-- //保存  重置   不关窗   -->
      <el-button
        type="primary"
        v-if="!popupConfig.scriptId"
        size="small"
        :disabled="submitting"
        @click="againAdd('ruleForm')"
        >再创建一条</el-button
      >
      <!-- <el-button type="primary" @click="submitForm('ruleForm')">完 成</el-button> //保存  关窗 -->
    </span>
  </el-dialog>
</template>
<script>
import {
  getScriptAdmin,
  getClassApi,
  editScript,
  addScript,
} from "@/api/sciptLibrary/index";

import MyUpload from "@/views/mass/SOP/components/myUpload.vue";
export default {
  components: {
    MyUpload,
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    popupConfig: {
      type: Object,
      default: () => {
        return {
          title: "",
          scriptId: "",
        };
      },
    },
  },
  data() {
    return {
      loading: false,
      submitting: false, //是否正在提交，防止重复点击创建多条
      hasSave: false, //是否保存过  是 关窗后请求列表接口
      loading1: false,
      loading2: false,
      loading3: false,
      oneOptions: [],
      twoOptions: [],
      threeOptions: [],
      ruleForm: {
        title: "",
        oneClassId: "",
        twoClassId: "",
        threeClassId: "",
        orderNo: 0,
        content: "",
        resourceVoList: [],
        linkVoList: [],
      },
      rules: {
        title: [
          { required: true, message: "话术标题", trigger: "blur" },
          {
            min: 0,
            max: 50,
            message: "长度在 0 到 50 个字符",
            trigger: "blur",
          },
        ],
        oneClassId: [{ required: true, message: "请选择", trigger: "change" }],
        // 二级、三级分类为非必填
        twoClassId: [{ required: false, message: "请选择", trigger: "change" }],
        threeClassId: [
          { required: false, message: "请选择", trigger: "change" },
        ],
        orderNo: [
          { required: true, message: "请输入排序值", trigger: "blur" },
          {
            pattern: /^\d{1,4}$/,
            message: "排序值必须为0-9999的数字",
            trigger: "blur",
          },
        ],
        content: [
          { required: true, message: "话术内容不能为空", trigger: "change" },
          { validator: this.validatePass, trigger: "change" },
        ],
      },
    };
  },
  watch: {
    popupConfig: {
      handler(newVal) {
        console.log("pop", this.popupConfig);
        if (newVal.scriptId.length > 0) {
          this.getPopupData();
        } else {
          this.getOneClassData();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    validatePass(rule, value, callback) {
      console.log("校验空格", value.replace(/\s+/g, "").length);
      if (value.replace(/\s+/g, "").length <= 0) {
        callback(new Error("请输出内容，空格不计"));
      } else {
        callback();
      }
    },
    // 获取分类列表(level:1/2/3, parentId:上级分类id, 一级传-1) 把接口的id映射为classId
    async fetchClassList(level, parentId) {
      try {
        const res = await getClassApi({ level, parentId }, true);
        let data = [];
        if (
          res &&
          res.error &&
          res.error.code == 200 &&
          Array.isArray(res.data)
        ) {
          data = res.data;
        } else if (res && res.code == 200 && Array.isArray(res.data)) {
          data = res.data;
        } else if (Array.isArray(res)) {
          data = res;
        }
        return data.map((item) => ({ ...item, classId: item.id }));
      } catch (e) {
        return [];
      }
    },
    async getOneClassData() {
      this.loading1 = true;
      this.oneOptions = await this.fetchClassList(1, -1);
      this.loading1 = false;

      if (this.ruleForm.oneClassId) {
        this.getTwoClassData();
      }
    },
    async getTwoClassData() {
      this.threeOptions = [];
      if (this.ruleForm.oneClassId) {
        this.loading2 = true;
        this.twoOptions = await this.fetchClassList(
          2,
          this.ruleForm.oneClassId,
        );
        this.loading2 = false;
      }
      if (this.ruleForm.twoClassId) {
        this.getThreeClassData();
      }
    },
    async getThreeClassData() {
      if (this.ruleForm.twoClassId) {
        this.loading3 = true;
        this.threeOptions = await this.fetchClassList(
          3,
          this.ruleForm.twoClassId,
        );
        this.loading3 = false;
      }
    },

    async getPopupData() {
      this.ruleForm.oneClassId = "";
      this.loading = true;
      // let res = await getScript(this.popupConfig.scriptId, true);
      let res = await getScriptAdmin(this.popupConfig.scriptId, true);
      console.log(66, res);
      if (res.error.code == 200) {
        const data = res.data;
        for (const key in data) {
          this.ruleForm[key] != undefined
            ? (this.ruleForm[key] = data[key])
            : "";
        }
        // 传递给父组件----
        res.data.content
          ? (this.ruleForm.content = res.data.content)
          : (this.ruleForm.content = "");
        if (res.data.resourceVoList && res.data.resourceVoList.length) {
          this.ruleForm.resourceVoList = res.data.resourceVoList.map(
            (item) => ({
              ...item,
              url: (item.url || item.resourceUrl || "").replace(/^`|`$/g, ""),
            }),
          );
        } else {
          this.ruleForm.resourceVoList = [];
        }
        // concat不会修改原数组，必须赋值，否则编辑时linkVoList为空，保存会清掉已有链接
        // 保存用后端返回的key，pictureUrl是带签名的完整URL仅用于渲染
        this.ruleForm.linkVoList = res.data.scriptLinkDtoList
          ? res.data.scriptLinkDtoList.map((item) => ({
              ...item,
              pictureUrl: item.key,
            }))
          : [];
        console.log("-----------------xxxxx", this.ruleForm, "xxx", res.data);

        this.$refs.myUploadRef.content = res.data.content;

        data.resourceVoList = res.data.resourceVoList
          ? res.data.resourceVoList
          : [];
        console.log("res.data.resourceVoList+_", data.resourceVoList);
        console.log(
          "this.ruleForm.resourceVoListdsfsdfsdf",
          this.ruleForm.resourceVoList,
        );
        data.resourceVoList.forEach((item) => {
          let fileUrl = (item.resourceUrl || item.url || "").replace(
            /^`|`$/g,
            "",
          );
          let obj = {
            url: fileUrl,
            name: item.resourceName,
            fileFullUrl: fileUrl,
          };
          console.log("itemitemitemXXXX", item);
          if (
            item.resourceType == "doc" ||
            item.resourceType == "pdf" ||
            item.resourceType == "xls" ||
            item.resourceType == "xlsx"
          ) {
            this.$refs.myUploadRef.uploadFileList.push(obj);
          } else if (item.resourceType == "mp4" || item.resourceType == "Mp4") {
            this.$refs.myUploadRef.videoList.push(obj);
          } else {
            this.$refs.myUploadRef.photoList.push(obj);
          }
        });
        data.linkVoList = res.data.scriptLinkDtoList
          ? res.data.scriptLinkDtoList
          : [];
        data.linkVoList.forEach((item) => {
          let obj = {
            title: item.title,
            httpUrl: item.httpUrl,
            content: item.content,
            // pictureUrl用后端返回的key（保存时回传），fileFullUrl用完整签名URL用于预览展示
            pictureUrl: item.key,
            pictureName: item.pictureName,
            fileFullUrl: item.pictureUrl,
          };
          // 只能显示一条
          this.$refs.myUploadRef.linkList.push(obj);
          this.$refs.myUploadRef.myFormLink = obj;
        });

        this.getOneClassData();
        console.log(888, this.ruleForm, this.$refs.myUploadRef, res.data);
      } else {
        // this.oneOptions = []
      }
      this.loading = false;
    },

    // 接受上传组件返回的参数
    receiveParam(obj) {
      console.log("obj", obj);
      // obj.content
      //   ? (this.ruleForm.content = obj.content)
      //   : (this.ruleForm.content = "");
      // obj.resourceVos.length
      //   ? this.ruleForm.resourceVoList.concat(obj.resourceVos)
      //   : (this.ruleForm.resourceVoList = []);
      // myUpload每次回传的是当前完整链接（仅支持一条），直接整体替换，避免重复push
      this.ruleForm.linkVoList = obj.linkVo ? [obj.linkVo] : [];
      if (obj.content) {
        this.ruleForm.content = obj.content;
      }
      if (obj.resourceVos.length > 0) {
        this.ruleForm.resourceVoList = obj.resourceVos;
      } else {
        if (this.ruleForm.resourceVoList.length <= 0) {
          this.ruleForm.resourceVoList = [];
        } else {
          this.ruleForm.resourceVoList = obj.resourceVos;
        }
      }
      console.log("数据更改XXXX", this.ruleForm);
    },

    //保存  不重置  不关窗  (编辑的时候关闭)
    submitForm(formName) {
      if (this.submitting) return;
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          if (this.submitting) return;
          this.submitting = true;
          this.loading = true;

          let res = "";
          try {
            if (this.popupConfig.scriptId) {
              res = await editScript(
                this.popupConfig.scriptId,
                this.ruleForm,
                true,
              );
            } else {
              res = await addScript(this.ruleForm, true);
            }
          } finally {
            this.submitting = false;
            this.loading = false;
          }
          if (res.error.code == 200) {
            this.hasSave = true;
            this.$message({
              type: "success",
              message: "保存成功",
            });

            this.handleClose();
          } else {
            this.$message({
              type: "error",
              message: res.error.message,
            });
          }
        } else {
          return false;
        }
      });
    },
    //再创建一条  重置
    againAdd(formName) {
      if (this.submitting) return;
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          if (this.submitting) return;
          this.submitting = true;
          this.loading = true;
          let res = "";
          try {
            if (this.popupConfig.scriptId) {
              res = await editScript(
                this.popupConfig.scriptId,
                this.ruleForm,
                true,
              );
            } else {
              res = await addScript(this.ruleForm, true);
            }
          } finally {
            this.submitting = false;
            this.loading = false;
          }
          if (res.error.code == 200) {
            this.hasSave = true;
            this.$message({
              type: "success",
              message: "保存成功",
            });

            this.$refs.myUploadRef.content = "";
            this.$refs.myUploadRef.photoList = [];
            this.$refs.myUploadRef.videoList = [];
            this.$refs.myUploadRef.uploadFileList = [];
            this.$refs.myUploadRef.linkList = [];
            this.$refs.myUploadRef.myFormLink = {};
            // myUpload内部的resourceVos/type也要重置，否则下一条纯文本话术会带上这一条的图片
            this.$refs.myUploadRef.resourceVos = [];
            this.$refs.myUploadRef.type = 0;
            // resetFields只重置注册的表单字段，linkVoList/resourceVoList需手动清空，避免带到下一条
            this.ruleForm.linkVoList = [];
            this.ruleForm.resourceVoList = [];
            this.twoOptions = [];
            this.threeOptions = [];
            this.$refs.ruleForm.resetFields();
            setTimeout(() => {
              console.log("this.ruleForm", this.ruleForm);
            }, 1000);
          } else {
            this.$message({
              type: "error",
              message: res.error.message,
            });
          }
        } else {
          return false;
        }
      });
    },

    handleClose() {
      this.$emit("update:dialogVisible", false);
      if (this.hasSave) {
        this.$emit("getData");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-select {
  width: 100%;
}
</style>
